import React from 'react'
import { Switch, Route, Redirect } from 'react-router-dom'
import { AboutUs, Terms, Faqs, ContactUs } from '../pages'

export default function MobileRoutes() {
  return (
    <Switch>
      <Route
        key='/mobile/contact-us'
        path='/mobile/contact-us'
        component={ContactUs}
      />
      <Route exact key='/mobile/faqs' path='/mobile/faqs' component={Faqs} />
      <Route
        key='/mobile/about-us'
        path='/mobile/about-us'
        component={AboutUs}
      />
      <Route key='/mobile/terms' path='/mobile/terms' component={Terms} />
      <Redirect to='/mobile/terms' />
    </Switch>
  )
}
